import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Chilean RUT validator following Single Responsibility Principle
 */
export class RutValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Chilean RUT',
      pattern: /^\d{1,2}\.\d{3}\.\d{3}-[\dK]$/i,
      minLength: 8,
      maxLength: 12
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    if (upperCaseId.length < this.config.minLength || upperCaseId.length > this.config.maxLength) {
      return ValidationResult.invalid('RUT length must be between 8 and 12 characters');
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'RUT format must be XX.XXX.XXX-X'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    const parts = upperCaseId.split('-');
    const digits = parts[0].replace(/\./g, '');
    const expectedChecksum = ChecksumCalculator.calculateRutChecksum(digits);
    const actualChecksum = parts[1];

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid RUT checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid RUT');
  }
}